/// <amd-module name="VSSUI/ReduxHeaderCommandBar" />
import * as React from "react";
import { Dispatch, AnyAction } from "redux";
import { connect } from "react-redux";

import { HeaderCommandBar, HeaderCommandBarWithFilter, IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { IObservableValue } from "VSS/Core/Observable";
import { FilterContext, IFilter } from "VSSUI/Utilities/Filter";
import { IMenuItem, IMenu } from "VSSUI/Menu";
import { MenuItem } from "VSSUI/Components/Menu/Menu";

export interface IHeaderCommand extends IHeaderCommandBarItem {
    /** Action to be dispatched onActivate */
    onActivateAction?: AnyAction;
}

export interface IReduxHeaderOwnProps {
    /**
     * When false does not show filter
     */
    showFilter: boolean;
    /**
     * This selector will be called to get latest set of commands
     */
    commandsSelector: (state: any, ownProps?: any) => IHeaderCommand[];
    /**
     * This selector will be called to get latest set of view actions
     */
    viewActionsSelector: (state: any, ownProps?: any) => IHeaderCommand[];
}

interface IHeaderCommandProps {
    showFilter: boolean;
    commands: IHeaderCommand[];
    viewActions: IHeaderCommand[];
    dispatch: Dispatch;
}

const ReduxHeaderCommandBar = (props: IHeaderCommandProps) => {
    const { commands, viewActions, dispatch, showFilter } = props;

    //viewActions.length can be zero when you want to render just the filter button
    if (commands.length === 0 && !viewActions) {
        return null;
    }

    const onActivate = (menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
        const headerCommand = menuItem as IHeaderCommand;
        if (headerCommand && headerCommand.onActivateAction) {
            dispatch(headerCommand.onActivateAction);
        }
    };

    // set onActivate for menu items to dispatch the action
    const setOnActivate = (command: IMenuItem) => {
        let subMenuProps = command.subMenuProps;
        if (subMenuProps && subMenuProps.items && Array.isArray(subMenuProps.items)) {
            subMenuProps.items.forEach(setOnActivate);
        }

        command.onActivate = command.onActivate || onActivate;
    };
    viewActions.forEach(setOnActivate);
    commands.forEach(setOnActivate);
    if (showFilter) {
        return (
            <FilterContext.Consumer>
                {(value: { filter: IFilter; filterToggled: IObservableValue<boolean> }) => (
                    <>
                        <HeaderCommandBar className="flex-grow justify-start" items={commands} />
                        <HeaderCommandBarWithFilter className="justify-end" filter={value.filter} filterToggled={value.filterToggled} items={viewActions} />
                    </>
                )}
            </FilterContext.Consumer>
        );
    }

    return (
        <>
            <HeaderCommandBar className="flex-grow justify-start" items={commands} />
            <HeaderCommandBar className="justify-end" items={viewActions} />
        </>
    );
};

const mapStateToProps = (state: any, ownProps: IReduxHeaderOwnProps) => {
    return {
        showFilter: ownProps.showFilter,
        commands: ownProps.commandsSelector(state, ownProps),
        viewActions: ownProps.viewActionsSelector(state, ownProps)
    };
};
export const ConnectedHeaderCommandBar = connect(
    mapStateToProps,
    dispatch => {
        return { dispatch };
    }
)(ReduxHeaderCommandBar);
